import { render, staticRenderFns } from "./LpHistoryEdit.vue?vue&type=template&id=5f47b362"
import script from "./LpHistoryEdit.vue?vue&type=script&lang=js"
export * from "./LpHistoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports